export default __webpack_public_path__ + "static/media/swiftstrikes7.19647baf.png";